export default "__VITE_ASSET__3c65f423__"